@let isAdmin = isAdminSg();
@let isCheckingAccess =
  surveyAdminsEc.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
@let selectedUserAccessType = selectedUserAccessTypeSg();
@let userAccessEc = userAccessEcSg();
@let isAddingSurveyAdmin =
  surveyAdminsEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal();
@let isAddingStandardUser =
  standardUsersEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal();
@let hasDeletions =
  userAccessEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal();
@let isSubmitting =
  userAccessEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

@if (isAdmin) {
  <atn-ds-page>
    <atn-ds-page-header
      pageHeader
      name="User Access"
    >
      <div
        selectors
        class="atn-space-user-access__header-selectors"
      >
        <atn-ds-select-single
          [items]="userAccessTypeSelectItems"
          [value]="selectedUserAccessType"
          [required]="true"
          (valueChange)="selectedUserAccessTypeChangedHandler($event)"
        />
      </div>
    </atn-ds-page-header>

    <atn-ds-table [config]="tableConfigSg()" />

    @if (isAddingSurveyAdmin) {
      <atn-space-add-survey-admin-modal />
    }

    @if (isAddingStandardUser) {
      <atn-space-add-standard-user-modal />
    }
  </atn-ds-page>

  @if (hasDeletions) {
    <atn-ds-confirmation-overlay
      [title]="'Delete ' + selectedUserAccessType + ' Assignment'"
      description="Deleting this assignment can't be undone. Are you sure you want to delete this assignment?"
      confirmButtonText="Delete"
      [loading]="isSubmitting"
      (confirm)="confirmDeletionClickHandler()"
      (cancel)="cancelDeletionClickHandler()"
    />
  }
} @else if (isCheckingAccess) {
  <div class="atn-space-user-access__loading-state">
    <atn-ds-loader
      type="page"
      message="Checking access..."
    />
  </div>
} @else {
  <div class="atn-space-user-access__empty-state-container">
    <div class="atn-space-user-access__empty-state-content">
      <atn-ds-empty-state
        type="no-data"
        title="You don't have access to this page"
        description="Only Platform, Tenant and Survey Admins can manage user access. Contact your administrator if you need access."
        layout="v"
      />
    </div>
  </div>
}
